/**
 * @generated SignedSource<<23ff114b173503163a63edf0c8fcb1a8>>
 * @relayHash b21637fe3a49b5737bd50184d35bd13f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e768500da4c5b363e5cf09fc5228973debdb98f58ec1bb2bbfbae1da84cd93b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiValidateJiraProjectsByJqlQuery } from './uiValidateJiraProjectsByJqlQuery.graphql';

const node: PreloadableConcreteRequest<uiValidateJiraProjectsByJqlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e768500da4c5b363e5cf09fc5228973debdb98f58ec1bb2bbfbae1da84cd93b9",
    "metadata": {},
    "name": "uiValidateJiraProjectsByJqlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
